import React from 'react';
import cn from 'classnames';
import Spinner from '@dealroadshow/uikit-loader/Spinner';
import Modal from '@dealroadshow/uikit-modal';
import { useAccessRequestContext } from '../../../../contexts/AccessRequestContext';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import { buttonStyles } from '@dealroadshow/uikit-button';
import styles from '../AlertsModal/alertsModal.module.scss';
import config from '@dataroom/config';
import { IDataroomListItem } from '../../../../domain/vo/DataroomListItem';

interface IProps {
  dataroom: IDataroomListItem,
  onClose: () => void,
  onSuccessCallback?: () => void,
}

const UnfollowModal = ({
  dataroom,
  onClose,
  onSuccessCallback,
}: IProps) => {
  const { tenant } = useDataroomTenantContext();
  const { tenantLabel } = config[tenant].options;

  const {
    isFetching,
    sendUnfollowRequest,
  } = useAccessRequestContext();

  if (!dataroom) {
    return null;
  }

  const handleUnfollowDataroom = () => {
    sendUnfollowRequest(dataroom)
      .then(onClose)
      .then(onSuccessCallback);
  };

  const footer = (
    <div>
      <button
        type="submit"
        onClick={ handleUnfollowDataroom }
        className={ buttonStyles.action }
        data-test="dataroomUnfollowButton"
      >
        Unfollow
      </button>
      <button
        type="button"
        onClick={ onClose }
        className={ buttonStyles.text }
        data-test="dataroomUnfollowCancelButton"
      >
        Cancel
      </button>
    </div>
  );

  return (
    <Modal
      onCloseClicked={ onClose }
      isVisible
      title={ (
        <div className={ cn(styles.title) }>
          <h5>
            { `Unfollow  “${ dataroom.displayName }” ` }
          </h5>
        </div>
      ) }
      footer={ footer }
      className={ styles.modal }
      onOverlayClicked={ onClose }
      dataTest="dataroomUnfollowModal"
    >
      <Spinner
        overlay
        isVisible={ isFetching }
      />
      Are you sure you want to Unfollow? By choosing to Unfollow this { tenantLabel } Set, you will lose access{ ' ' }
      to all documents and email notifications. Should you want to regain access to this { tenantLabel },{ ' ' }
      you will be required to reach out to the Set Admin or { tenantLabel } Support Team for further assistance.
    </Modal>
  );
};

export default UnfollowModal;
